import axios from "../../axios";
import {
  NOTIFICATION_LIST_SUCCESS,
  NOTIFICATION_LIST_REQUEST,
  NOTIFICATION_LIST_FAIL,
//   
  NOTIFICATION_MARK_READ_REQUEST,
  NOTIFICATION_MARK_READ_SUCCESS,
  NOTIFICATION_MARK_READ_FAIL,
//   
  NOTIFICATION_MARK_ALL_READ_REQUEST,
  NOTIFICATION_MARK_ALL_READ_SUCCESS,
  NOTIFICATION_MARK_ALL_READ_FAIL,
//   
NOTIFICATION_UNREAD_LIST_SUCCESS,
  NOTIFICATION_UNREAD_LIST_REQUEST,
  NOTIFICATION_UNREAD_LIST_FAIL,
  //
} from "../constants/notificationConstants";
import { toast } from "react-toastify";


// get all notifications
export const getListNotifications = (page) => async (dispatch, getState) => {
    try {
      dispatch({
        type: NOTIFICATION_LIST_REQUEST,
      });
      var {
        userLogin: { userInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.access}`,
        },
      };
      const { data } = await axios.get(`/notifications/?page=${page}`, config);

      dispatch({
        type: NOTIFICATION_LIST_SUCCESS,
        payload: data,
      });
    } catch (error) {
      var err =
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.detail;
      if (err) {
        if (
          err === "Given token not valid for any token type" ||
          err === "User not found"
        ) {
          localStorage.removeItem("userInfoExpressHalalAdmin");
          document.location.href = "/";
        }
      }
      dispatch({
        type: NOTIFICATION_LIST_FAIL,
        payload:
          error.response && error.response.data.detail
            ? error.response.data.detail
            : error.detail,
      });
    }
  };

// get all notifications without pagination (for notification check)
export const checkUnreadNotifications = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: NOTIFICATION_UNREAD_LIST_REQUEST,
    });
    var {
      userLogin: { userInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.access}`,
      },
    };
    // Use page=0 to get all notifications without pagination
    const { data } = await axios.get(`/notifications/?page=0`, config);

    dispatch({
      type: NOTIFICATION_UNREAD_LIST_SUCCESS,
      payload: data,
    });

    return data;
  } catch (error) {
    var err =
      error.response && error.response.data.detail
        ? error.response.data.detail
        : error.detail;
    if (err) {
      if (
        err === "Given token not valid for any token type" ||
        err === "User not found"
      ) {
        localStorage.removeItem("userInfoExpressHalalAdmin");
        document.location.href = "/";
      }
    }
    dispatch({
      type: NOTIFICATION_UNREAD_LIST_FAIL,
      payload:
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.detail,
    });

    return null;
  }
};

// mark notification as read
export const markNotificationAsRead = (notificationId) => async (dispatch, getState) => {
  try {
    dispatch({
      type: NOTIFICATION_MARK_READ_REQUEST,
    });

    var {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.access}`,
      },
    };

    const { data } = await axios.put(
      `/notifications/${notificationId}/mark-read/`,
      {},
      config
    );

    dispatch({
      type: NOTIFICATION_MARK_READ_SUCCESS,
      payload: data,
    });

    // Refresh the notifications list
    dispatch(getListNotifications(1));

    toast.success("Notification marked as read");

  } catch (error) {
    var err =
      error.response && error.response.data.detail
        ? error.response.data.detail
        : error.detail;
    if (err) {
      if (
        err === "Given token not valid for any token type" ||
        err === "User not found"
      ) {
        localStorage.removeItem("userInfoExpressHalalAdmin");
        document.location.href = "/";
      }
    }

    toast.error("Failed to mark notification as read");

    dispatch({
      type: NOTIFICATION_MARK_READ_FAIL,
      payload:
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.detail,
    });
  }
};

// mark all notifications as read
export const markAllNotificationsAsRead = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: NOTIFICATION_MARK_ALL_READ_REQUEST,
    });

    var {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.access}`,
      },
    };

    const { data } = await axios.put(
      `/notifications/mark-all-read/`,
      {},
      config
    );

    dispatch({
      type: NOTIFICATION_MARK_ALL_READ_SUCCESS,
      payload: data,
    });

    // Refresh the notifications list
    dispatch(getListNotifications(1));

    toast.success("All notifications marked as read");

  } catch (error) {
    var err =
      error.response && error.response.data.detail
        ? error.response.data.detail
        : error.detail;
    if (err) {
      if (
        err === "Given token not valid for any token type" ||
        err === "User not found"
      ) {
        localStorage.removeItem("userInfoExpressHalalAdmin");
        document.location.href = "/";
      }
    }

    toast.error("Failed to mark all notifications as read");

    dispatch({
      type: NOTIFICATION_MARK_ALL_READ_FAIL,
      payload:
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.detail,
    });
  }
};